import { render, staticRenderFns } from "./NotificationRibbon.vue?vue&type=template&id=c3b5c80a&scoped=true&"
import script from "./NotificationRibbon.vue?vue&type=script&lang=js&"
export * from "./NotificationRibbon.vue?vue&type=script&lang=js&"
import style0 from "./NotificationRibbon.vue?vue&type=style&index=0&id=c3b5c80a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.registry.npmjs.org/vue-loader/15.9.7_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3b5c80a",
  null
  
)

export default component.exports